import React from "react";
import { StyledDiv, StyledSpan } from "./_.styled";
import OtherLanguagesContainer from "./OtherLanguagesContainer";

const ContentHeaderOtherLanguagesWrapper = ({
  label,
  testId: otherLanguagesTestId,
  languageList,
}) => {
  return (
    <StyledDiv data-testid={otherLanguagesTestId}>
      <StyledSpan>{label}</StyledSpan>
      <OtherLanguagesContainer languageList={languageList} />
    </StyledDiv>
  );
};

ContentHeaderOtherLanguagesWrapper.displayName =
  "ContentHeaderOtherLanguagesWrapper";

export default ContentHeaderOtherLanguagesWrapper;
